import  { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const userData = localStorage.getItem("UserData");
    if (!userData) {
      navigate("/login");
    }
  }, [navigate]);

  return children;
};

export default ProtectedRoute;
